// extracted by mini-css-extract-plugin
var _1 = "ProvisionTypeSelectOption-module__badgeWrapper--pk2AZ";
var _2 = "ProvisionTypeSelectOption-module__value--LTPIQ";
export { _1 as "badgeWrapper", _2 as "value" }
